import { render, staticRenderFns } from "./NavSwiper.vue?vue&type=template&id=7f04ec6b&scoped=true&"
import script from "./NavSwiper.vue?vue&type=script&lang=js&"
export * from "./NavSwiper.vue?vue&type=script&lang=js&"
import style0 from "./NavSwiper.vue?vue&type=style&index=0&id=7f04ec6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f04ec6b",
  null
  
)

export default component.exports